<template>
  <div id="v2-product-events-item">
    <div class="left">
      <div class="top">
        <h3>
          <i
            v-if="$store.state.isPromo && is_countdown"
            class="anyteachicon anyteach-1212 promo-icon"
          />
          <span v-if="title">{{ title }}</span>
          <span v-else-if="start_time && end_time"
            >{{ $moment(start_time).format("M月D日") }}场</span
          >
        </h3>
        <h4 v-if="subtitle">{{ subtitle }}</h4>
        <!-- <p v-if="detail" class="detail">{{ detail }}</p> -->
        <p v-if="start_time && end_time">{{ time }}</p>
        <p v-if="address">
          <i class="anyteachicon anyteach-map-marker-alt" />
          {{ address }}
        </p>
        <p v-if="total && total > done">仅剩 {{ total - done }} 个名额</p>
        <p v-if="show_time && $moment().isBefore($moment(show_time), 'second')">
          {{ $moment(show_time).format("M月D日 HH:mm:ss") }} 开售
        </p>
        <div
          v-if="
            (!now.isAfter($moment(show_time), 'second') && !show_time) ||
              now.isAfter($moment(show_time), 'second')
          "
        >
          <p class="countdown__off" v-if="isCountdownOff && countdownOff">
            {{ countdownOff }} 后结束
          </p>
          <p v-else-if="!isCountdownOff && shelf_time">
            {{ $moment(shelf_time).format("M月D日 HH:mm:ss") }} 下架
          </p>
        </div>
      </div>
      <div v-if="is_limited || is_first || is_coupon" class="bottom">
        <h5 v-if="is_limited">
          <i class="anyteachicon anyteach-zhifu-01" />
          <span>限购 1 次</span>
        </h5>
        <h5 v-if="is_first">
          <i class="anyteachicon anyteach-youhui" />
          <span>首单减 ¥{{ is_first }}</span>
        </h5>
        <h5 v-if="is_coupon && meta && price > 0 && meta.user_coupon.length">
          <i class="anyteachicon anyteach-youhuiquan1" />
          <span>{{ meta.user_coupon.length }} 张券可用</span>
        </h5>
      </div>
    </div>
    <div class="right">
      <button
        v-if="show_time && now.isBefore($moment(show_time), 'second')"
        :style="setBgd"
        class="disabled"
      >
        ¥{{ price }}
      </button>
      <button
        v-else-if="now.isAfter($moment(shelf_time), 'second')"
        :style="setBgd"
        class="disabled"
      >
        ¥{{ price }}
      </button>
      <button
        v-else-if="(is_limited && is_buy) || (total && total == done)"
        :style="setBgd"
        class="disabled"
      >
        ¥{{ price }}
      </button>
      <button
        v-else-if="meta.is_first && !is_buy"
        :style="setBgd"
        @click="$emit('pay', meta)"
        :class="{ promo__button: $store.state.isPromo && is_countdown }"
      >
        ¥{{ price - is_first }}
      </button>
      <button
        v-else
        :style="setBgd"
        :class="{ promo__button: $store.state.isPromo && is_countdown }"
        @click="$emit('pay', meta)"
      >
        ¥{{ price }}
      </button>
      <p v-if="show_time && now.isBefore($moment(show_time), 'second')">未开售</p>
      <p v-else-if="now.isAfter($moment(shelf_time), 'second')">已下架</p>
      <p v-else-if="is_buy">已购买</p>
      <p v-else-if="total && total == done">名额已满</p>
      <p v-else-if="is_first && !is_buy && meta.is_first">
        <s>原价：¥{{ price }}</s>
      </p>
    </div>
  </div>
</template>

<script>
import moment from "dayjs"
// import moment from "moment"
// import momentDurationFormatSetup from "moment-duration-format"
import mixin from "../product/mixin"

export default {
  name: "Item",
  mixins: [mixin],
  props: [
    "now",
    "id",
    "title",
    "subtitle",
    "detail",
    "start_time",
    "end_time",
    "address",
    "price",
    "show_time",
    "shelf_time",
    "done",
    "total",
    "is_countdown",
    "is_first",
    "is_buy",
    "is_coupon",
    "is_limited",
    "color"
  ],
  data() {
    return {
      meta: "",
      time: `${moment(this.start_time).format("M月D日 HH:mm")} — ${moment(this.start_time).isSame(this.end_time, "day")
        ? ""
        : moment(this.end_time).format("M月D日")
        // eslint-disable-next-line indent
        } ${moment(this.end_time).format("HH:mm")}`,
      isCountdownOff: false,
      countdownOff: null,
      countdownOffInstance: null,
    }
  },
  created() {
    this.getFirstOrVoucher()
    // momentDurationFormatSetup(moment)

    // this.isCountdownOff =
    //   this.shelf_time &&
    //   this.is_countdown &&
    //   (this.now.isSame(moment(this.shelf_time), "day") ||
    //     moment(this.shelf_time).diff(this.now, "hours") < 2) &&
    //   this.now.isBefore(moment(this.shelf_time), "second")
    // if (this.is_countdown) {
    //   this.countdownOffInstance = setInterval(this.startCountdownOff(), 1000)
    // }
  },
  // beforeDestroy() {
  //   if (this.countdownOffInstance) {
  //     clearInterval(this.countdownOffInstance)
  //   }
  // },
  methods: {
    checkRoute() {
      const { query } = this.$route
      if (query.pay && query.cd_id && Number(query.cd_id) == this.id) {
        this.$emit("pay", this.meta)
      }
    },
    // startCountdownOff() {
    //   const shelf_time = moment(this.shelf_time)
    //   const diff = shelf_time.diff(this.now, "seconds")
    //   this.countdownOff = moment.duration(diff, "seconds").format("hh:mm:ss", {
    //     trim: false,
    //   })
    //   if (diff == 0) {
    //     this.countdownOff = null
    //     return clearInterval(this.countdownOffInstance)
    //   }
    //   return this.startCountdownOff
    // },
    async getFirstOrVoucher() {
      const config = {
        url: v2Url + "/course/firstOrVoucher",
        method: "POST",
        data: { id: this.id },
      }
      let { data } = await this.$axios(config)
      this.meta = data.code == 1000 ? data.msg : null
      this.checkRoute()
    },
  },
}
</script>

<style scoped lang="scss">
@import "../style.scss";
@import "@/assets/css/promo.scss";

#v2-product-events-item {
  display: flex;
  padding: 20px 15px;
  margin: 10px auto;
  max-width: 500px;
  @include card();
  &:first-of-type {
    margin-top: 20px;
  }

  .left {
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .detail {
      font-weight: 400;
      font-size: 12px;
    }
    .bottom {
      margin: 5px 0 -10px 0;
      h5 {
        font-size: 12px;
        font-weight: 400;
        display: inline;
        margin: 0 5px 0 0;
        i {
          margin: 0 3px 0 0;
        }
      }
    }
    h3 {
      font-size: 1rem;
      font-weight: bold;
      line-height: 1.2;
      .promo-icon {
        font-size: inherit;
      }
    }
    h4 {
      font-size: 0.85rem;
      font-weight: 400;
      opacity: 0.6;
      line-height: 1.3;
    }
    p {
      line-height: 18px;
      font-size: 13px;
      font-weight: 300;
    }
    .countdown__off {
      background: $red;
      background: $d11__main;
      color: white;
      padding: 2px 5px;
      display: inline-block;
      border-radius: 4px;
      font-weight: 400;
    }
  }
  .right {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;

    button {
      background-color: $lightBlue;
      color: white;
      border-radius: 20px;
      min-width: 50px;
      padding: 7px 5px;
      border: none;
      font-size: 13px;
      margin: 0 auto;
      box-sizing: content-box;
      @include avenir-demi();
      transition: 0.1s;
      &:active {
        transform: scale(0.9);
      }
    }
    button[disabled],
    button.disabled {
      background-color: #eee !important;
      color: $black !important;
      opacity: 0.6;
      &:active {
        transform: none;
      }
    }
    .promo__button {
      background-color: $d11__bgd;
      color: $d11__main;
    }
    p {
      text-align: center;
      width: 100%;
      font-size: 12px;
      font-weight: 400;
      transform: scale(0.9);
      height: 0;
      opacity: 0.5;
      white-space: nowrap;
    }
  }
}
#v2-product-events-item:last-of-type {
  margin-bottom: 0;
}
</style>
